module.exports = __webpack_public_path__ + "img/p2pplatforms.e7330558.png";